import { type ReactNode } from 'react';

export type EndProps = {
  children?: ReactNode;
};

// Renders nothing because it's only used for footer placement verification on ./index.tsx
export const End = (_props: EndProps) => {
  return null;
};
